import ChakraIcon, { IconProps as ChakraIconProps } from "@chakra-ui/icon";

export type IconProps = ChakraIconProps;

export const Icon = ({ boxSize = 6, ...props }: IconProps) => (
  <ChakraIcon viewBox="0 0 32 32" boxSize={boxSize} {...props} />
);
